<template>
  <div class="modal-backdrop" @click="close">
    <div class="modal" @click.stop>
      <div class="modal-header">
        <div name="header">
          Let op!
        </div>
        <button
            type="button"
            class="btn-close"
            @click="close"
        >
          <div class="icon-wrapper close">
            <i class="material-icons-round btn-close">close</i>
          </div>
        </button>
      </div>

      <div class="modal-body">
        <div class="disclaimer small">
          We gebruiken je paspoort / ID-kaart om te verifiëren wie je bent en wanneer je aan de slag gaat via Derect worden de nodige gegevens automatisch overgenomen voor op de overeenkomst. Makkelijk en veilig dus! Voor meer informatie kun je onze privacy voorwaarden bekijken.
        </div>
        <div v-if="documentType === 'P'" class="section-title">Eisen aan foto's van een paspoort:</div>
        <div v-else-if="documentType === 'I'" class="section-title">Eisen aan foto's van een ID-kaart:</div>
        <div v-else-if="documentType === 'V'" class="section-title">Eisen aan foto's van een verblijfsvergunning:</div>
        <div class="rule-row">
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/check-icon.png" />
                </div>
                <img v-if="documentType === 'P'" class="rule-img" src="@/assets/id-passport/passport-correct-frontside.png" />
                <img v-else-if="documentType === 'I' || documentType === 'V'" class="rule-img" src="@/assets/id-passport/id-correct-frontside.png" />
              </div>
            </div>
          </div>
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/check-icon.png" />
                </div>
                <img v-if="documentType === 'P'" class="rule-img" src="@/assets/id-passport/passport-correct-backside.png" />
                <img v-else-if="documentType === 'I' || documentType === 'V'" class="rule-img" src="@/assets/id-passport/id-correct-backside.png" />
              </div>
            </div>
          </div>
        </div>
        <br>
        <ul class="rule-list">
          <li class="rule-list-item">Alle randen zichtbaar</li>
          <li class="rule-list-item">Minimaal ruimte er omheen</li>
          <li class="rule-list-item" v-if="documentType === 'P'">Beide pagina's in beeld</li>
          <li class="rule-list-item" v-if="documentType === 'P'">Horizontale (tekst) weergave</li>
          <li class="rule-list-item" v-else-if="documentType === 'I' || documentType === 'V'">Horizontale (tekst) weergave</li>
          <li class="rule-list-item">Gelijkmatig belicht</li>
          <li class="rule-list-item">Geen flits, lichtreflectie of schaduw</li>
          <li class="rule-list-item">Alles leesbaar en scherp</li>
          <li class="rule-list-item">Lichte/neutrale achtergrond</li>
        </ul>
        <br>
        <div class="section-title">Voorbeelden van foute foto's:</div>
        <div class="rule-row" v-if="documentType === 'I' || documentType === 'V'">
          <div class="rule-text-wrong">Geen witte achtergrond &<br> te veel ruimte er omheen</div>
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/cross-icon.png" />
                </div>
                <img class="rule-img" src="@/assets/id-passport/id-wrong-background.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="rule-row" v-if="documentType === 'P'">
          <div class="rule-text-wrong">Ontbrekende pagina & afgesneden randen</div>
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/cross-icon.png" />
                </div>
                <img class="rule-img" src="@/assets/id-passport/passport-wrong-crop.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="rule-row">
          <div class="rule-text-wrong">Te donker</div>
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/cross-icon.png" />
                </div>
                <img v-if="documentType === 'P'" class="rule-img" src="@/assets/id-passport/passport-wrong-dark.png" />
                <img v-else-if="documentType === 'I' || documentType === 'V'" class="rule-img" src="@/assets/id-passport/id-wrong-dark.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="rule-row">
          <div class="rule-text-wrong">Onleesbaar gemaakt</div>
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/cross-icon.png" />
                </div>
                <img v-if="documentType === 'P'" class="rule-img" src="@/assets/id-passport/passport-wrong-unreadable.png" />
                <img v-else-if="documentType === 'I' || documentType === 'V'" class="rule-img" src="@/assets/id-passport/id-wrong-unreadable.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="rule-row">
          <div class="rule-text-wrong">Scheef in beeld</div>
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/cross-icon.png" />
                </div>
                <img v-if="documentType === 'P'" class="rule-img" src="@/assets/id-passport/passport-wrong-alignment.png" />
                <img v-else-if="documentType === 'I' || documentType === 'V'" class="rule-img" src="@/assets/id-passport/id-wrong-alignment.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="rule-row">
          <div class="rule-text-wrong">Vingers in beeld</div>
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/cross-icon.png" />
                </div>
                <img v-if="documentType === 'P'" class="rule-img" src="@/assets/id-passport/passport-wrong-finger.png" />
                <img v-else-if="documentType === 'I' || documentType === 'V'" class="rule-img" src="@/assets/id-passport/id-wrong-finger.jpg" />
              </div>
            </div>
          </div>
        </div>
        <div class="rule-row">
          <div class="rule-text-wrong">Zwart-wit kopie</div>
          <div class="rule-image-icon">
            <div class="rule-image-container">
              <div class="rule-image-container-inner">
                <div class="rule-icon-container">
                  <img class="rule-icon" src="@/assets/cross-icon.png" />
                </div>
                <img v-if="documentType === 'P'" class="rule-img" src="@/assets/id-passport/passport-wrong-blackwhite.png" />
                <img v-else-if="documentType === 'I' || documentType === 'V'" class="rule-img" src="@/assets/id-passport/id-wrong-blackwhite.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="rule-row">
          <button class="btn btn-warning btn-block" @click="confirm">
            Ik begrijp het!
          </button>
        </div>
        <div class="rule-row small">
          Wanneer je op "Ik begrijp het!" klikt kan je foto's uploaden door nogmaals op de uploadknoppen te klikken
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IdInstructionModal',
  props: {
    documentType: String //P = passport, I = ID, V = verblijfsvergunning
  },
  methods: {
    close() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('confirm');
    }
  }
}
</script>
<style scoped>

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  position: relative;
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  display: flex;
  flex-direction: column;
  max-width: 600px;
  max-height: 80%;
  border-radius: 15px;
  scrollbar-width: none;
  overflow: hidden;
}

.modal-header {
  padding: 15px;
  display: flex;
  position: relative;
  font-size: 24px;
  color: #625a55;
  justify-content: center;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
  overflow: auto;
}

.section-title {
  font-size: 20px;
}

.rule-row {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.rule-text-wrong {
  display: inline-block;
  width: 50%;
  padding-left: 10px;
  padding-right: 10px;
}

.rule-image-icon {
  display: inline-block;
  width: 50%;
}

.rule-image-container {
  width: 100%;
}

.rule-image-container-inner {
  display: inline-block;
  width: auto;
  position: relative;
}

.rule-img {
  max-width: 100%;
  max-height: 240px;
}

.rule-icon-container {
  position: absolute;
  right: 0;
  bottom: 0;
}

.rule-icon {
  max-height: 40px;
}

.rule-list {
  list-style: none;
  margin: 0;
  padding: 0;
  text-align: center;
}

.rule-list-item {
  width: 100%;
  padding-left: 10px;
}

.rule-list-item:before {
  content: "\2713 ";
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #625a55;
  background: transparent;
}

.btn-close:hover {
  color: #625a55;
}

.disclaimer {
  margin-bottom: 10px;
}

</style>